import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CUSTOM_LIST_SLICE } from "./sliceNames";
import { CUSTOM_LIST_INITIAL_VALUE } from "constants/initialValue";
import { ICustomList } from "interfaces/MarketingTools/customList.interface";

const customListSlice = createSlice({
  name: CUSTOM_LIST_SLICE,
  initialState: CUSTOM_LIST_INITIAL_VALUE,
  reducers: {
    fetchCustomListForSlice: (
      state,
      action: PayloadAction<{
        customList?: ICustomList[];
      }>,
    ) => {
      return {
        ...state,
        isFetchingCustomList: true,
        ...action.payload,
      };
    },
    addCustomListToSlice: (
      state,
      action: PayloadAction<{
        customList: ICustomList[];
      }>,
    ) => {
      return {
        ...state,
        isFetchingCustomList: false,
        ...action.payload,
      };
    },
    updateCustomListSlice: (
      state,
      action: PayloadAction<{
        customList?: ICustomList[];
        isFetchingCustomList: boolean;
      }>,
    ) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetCustomListSlice: () => {
      return CUSTOM_LIST_INITIAL_VALUE;
    },
  },
});

export const {
  addCustomListToSlice: actionAddCustomListToSlice,
  resetCustomListSlice: actionResetCustomListSlice,
  updateCustomListSlice: actionUpdateCustomListSlice,
  fetchCustomListForSlice: actionFetchCustomListForSlice,
} = customListSlice.actions;

export default customListSlice.reducer;
